export const htmlTemplates = (text, location) => ({
  popupSuccessTemplate: '<button type="button" class="btn btn-primary d-none" id="liveToastBtn">Show live toast</button>\n'
    + '\n'
    + '<div class="cvf_success-content-wrapper position-fixed bottom-50 d-block mx-auto rounded-5 h-25">\n'
    + '    <div id="cvf_popup-toast" class="toast hide rounded-5 px-2 py-5 border-0" role="alert" aria-live="assertive" aria-atomic="true">\n'
    + '        <div class="toast-header w-100 border-0">\n'
    + '            <p class="w-100 text-center">'+ (text ? text : 'Dziękujemy za przesłanie zgłoszenia!') +'</p>\n'
    + '        </div>\n'
    + '        <p class="text-center">Twoje dane zostały zapisane</p>\n'
    + '        <div class="d-flex justify-content-between align-items-center w-75 m-auto">\n'
      + '        <a onclick="'+((location == 'mainPage')? "location.replace('/')" : "location.reload()")+'" target="_self" class="rounded-3 d-inline-block mx-auto px-4 py-1 my-2">OK</a></div>\n'
    + '    </div>\n'
    + '</div>\n'
    + '\n',
  popupFailTemplate: '<button type="button" class="btn btn-primary d-none" id="liveToastBtn">Show live toast</button>\n'
    + '\n'
    + '<div class=" cvf_fail-content-wrapper position-fixed bottom-50 d-block mx-auto rounded-5 h-25">\n'
    + ' <div class=" cvf_scroll-class rounded-5 shadow">\n'
    + '    <div id="cvf_popup-toast" class="toast hide px-2 py-5 border-0" role="alert" aria-live="assertive" aria-atomic="true">\n'
    + '        <div class="toast-header w-100 border-0">\n'
    + '            <p class="w-100 text-center font-weight-bold">Niepoprawnie wypełniony formularz!</p>\n'
    + '        </div>\n'
    + '        <p class="text-center cvf_incorrect-fields">Sprawdź poniższe pola:<br></p>\n'
    + '        <button type="button" class="rounded-3 d-block mx-auto px-4 py-1 my-2" data-bs-dismiss="toast" aria-label="OK">OK</button>\n'
    + '    </div>\n'
    + ' </div>\n'
    + '</div>\n'
    + '\n',
  popupNoCheckboxesTemplate: '<button type="button" class="btn btn-primary d-none" id="liveToastBtn">Show live toast</button>\n'
        + '\n'
        + '<div class=" cvf_fail-content-wrapper position-fixed bottom-50 d-block mx-auto rounded-5 h-25">\n'
        + '    <div id="cvf_popup-toast" class="toast hide rounded-5 px-2 py-5 border-0" role="alert" aria-live="assertive" aria-atomic="true">\n'
        + '        <div class="toast-header w-100 border-0">\n'
        + '            <p class="w-100 text-center font-weight-bold">Niepoprawnie wypełniony formularz!</p>\n'
        + '        </div>\n'
        + '        <p class="text-center cvf_incorrect-fields">Zaznacz wszystkie wymagane zgody<br></p>\n'
        + '        <button type="button" class="rounded-3 d-block mx-auto px-4 py-1 my-2" data-bs-dismiss="toast" aria-label="OK">OK</button>\n'
        + '    </div>\n'
        + '</div>\n'
        + '\n',
});
